// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Q9e3mPXG{display:flex;flex-direction:column;flex-grow:1}.Y4BMK5DV{display:flex;flex-wrap:wrap;font-size:max(.88rem,min(.83vw,1rem));gap:.5em 1em;justify-content:flex-end}@media(max-width:667.98px){.Y4BMK5DV{justify-content:flex-start}}.XVLddBUX{align-items:center;display:flex}@media(hover:hover){.XVLddBUX:hover{-webkit-text-decoration:underline;text-decoration:underline}}@media(hover:none){.XVLddBUX:active{-webkit-text-decoration:underline;text-decoration:underline}}.-Vy69p2-{--size:1.2em;margin-right:.5em}.JBsZvAwb{margin-bottom:var(--spacing-md)}.JBsZvAwb>:first-child{padding-bottom:0!important}.diE2tek8{color:var(--color-danger);margin-bottom:var(--spacing-md)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "Q9e3mPXG",
	"pdfs": "Y4BMK5DV",
	"pdf": "XVLddBUX",
	"pdfIcon": "-Vy69p2-",
	"heading": "JBsZvAwb",
	"notice": "diE2tek8"
};
module.exports = ___CSS_LOADER_EXPORT___;
